import {gql} from 'apollo-angular';

export const CREATE_BOOKMARK = gql`
  query CreateBookmark {
    bookmarkCreate {
      accessToken
    }
  }
`;
